module.exports = __webpack_public_path__ + "static/media/wecode.d08a26b4.svg";